import ApiFiltersAction from '../lawyer-api/filters-action';
import Plugin from '../plugin';
import UserSettings from '../../utility/user-settings';
import {FiltersResult} from '../../../types/filters-result';

/**
 * Filters for the publication list.
 *
 * @author Philipp Seiler <ps@typoheads.at>
 */
export default class FiltersAction extends ApiFiltersAction {
  constructor(plugin: Plugin, container: HTMLElement) {
    super(plugin, container, 'publications/filters');
    this.update(UserSettings.getInstance().getPluginSettings(plugin.name));
  }


  protected initializeResult(result: FiltersResult, settings: any) {
    super.initializeResult(result, settings);

    // Render handlebar template
    const template = require('../../templates/publication/filters.handlebars');
    this.container.innerHTML = template({
      'filters': result
    });

    this.initializeControls();
    this.markReady();
  }
}
